import { isPlatformBrowser } from "@angular/common";
import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject, PLATFORM_ID } from "@angular/core";
import { jwtDecode } from "jwt-decode";
import { catchError, throwError } from "rxjs";
import { LocalStorageService } from "../services/local-storage.service";
import { SKIP_ERROR_INTERCEPTOR } from "./skip-interceptor.token";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  const localStorageService = new LocalStorageService();

  let authToken = null;

  if (req.url.includes("maps.googleapis.com")) {
    return next(req);
  }

  const skip = req.context.get(SKIP_ERROR_INTERCEPTOR);

  if (skip) {
    // Não faz nenhum tratamento de erro, só segue
    return next(req);
  }

  if (isPlatformBrowser(platformId) && !req.url.includes("viacep")) {
    authToken = localStorageService.getItem("auth-token");
  }

  if (authToken) {
    const payload = jwtDecode(authToken);

    if (Date.now() >= payload.exp! * 1000) {
      localStorageService.clear();
      window.location.reload();
      console.error("Token expirado");
    } else {
      req = req.clone({
        setHeaders: { Authorization: `Bearer ${authToken}` },
      });
    }
  }

  return next(req).pipe(
    catchError((err) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          localStorageService.clear();
          if (!req.url.includes("/login")) {
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
          return throwError(
            () => new Error("Token não autorizado ou expirado"),
          );
        }
        if (err.status === 502) {
          return throwError(() => new Error("Problemas com o servidor!"));
        }
      }
      return throwError(() => err);
    }),
  );
};
